import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeContextProvider } from './theme/ThemeContext';
import { AuthProvider, useAuth } from './providers/AuthProvider';
import { AppShell } from './components/layout';
import LoginPage from './pages/auth/LoginPage';
import MachinesPage from './pages/machines/MachinesPage';
import MachineDetailPage from './pages/machines/MachineDetailPage';
import SitesPage from './pages/sites/SitesPage';
import TemplatesPage from './pages/templates/TemplatesPage';
import TemplateBuilderPage from './pages/templates/TemplateBuilderPage';
import SchedulesPage from './pages/schedules/SchedulesPage';
import TasksPage from './pages/tasks/TasksPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import ResultsPage from './pages/results/ResultsPage';
import AlertsPage from './pages/alerts/AlertsPage';
import SettingsPage from './pages/settings/SettingsPage';
import UsersPage from './pages/users/UsersPage';
import ProfilePage from './pages/profile/ProfilePage';
import UserAssignmentsPage from './pages/operator/UserAssignmentsPage';
import OperatorFormPage from './pages/operator/OperatorFormPage';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <ThemeContextProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/" element={<DashboardPage />} />

              {/* Dashboard */}
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/alerts" element={<AlertsPage />} />

              {/* Admin */}
              <Route path="/machines" element={<MachinesPage />} />
              <Route path="/machines/:id" element={<MachineDetailPage />} />
              <Route path="/sites" element={<SitesPage />} />
              <Route path="/templates" element={<TemplatesPage />} />
              <Route path="/templates/:id/edit" element={<TemplateBuilderPage />} />
              <Route path="/schedules" element={<SchedulesPage />} />
              <Route path="/tasks" element={<TasksPage />} />
              <Route path="/config" element={<SettingsPage />} />

              {/* Operator */}
              <Route path="/assignments" element={<UserAssignmentsPage />} />
              <Route path="/assignments/:formId" element={<OperatorFormPage />} />

              {/* Settings */}
              <Route path="/users" element={<UsersPage />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeContextProvider>
  );
};

export default App;
